import Styles from './BatchModals.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Input } from 'almanac-ui/TextInputField/Input'

interface Props {
  topic: string
  setTopic: (value: string) => void
}

export const Topic = ({ topic, setTopic }: Props) => {
  return (
    <div className={Styles.topic}>
      <label htmlFor="topic">
        <div className={Styles.label}>
          <Heading level={5}>Focus content on a single topic</Heading>
          <Text color="var(--dark-60)" variant="placeholder">
            Optional
          </Text>
        </div>
      </label>
      <Input
        name="topic"
        value={topic}
        onChange={(e) => setTopic(e.target.value)}
        autoComplete="off"
        autoFocus
        id="topic"
        placeholder="Briefly describe a topic to focus the content on..."
        size="lg"
      />
    </div>
  )
}
